import React from 'react';
import styled from "@emotion/styled";

import { Modal } from './compound/Modal';
import {ModalContent} from "./constant/Modal";

interface CommonModalProps {
    open: boolean;
    onClose: () => void;
    modalMsg: ModalContent;
    onConfirm?: () => void;
    onCancel?: () => void;
    button2Variant?: string;
}

export const CommonModal = ({open, onClose, modalMsg, onConfirm, onCancel, button2Variant = "black"}: CommonModalProps) => {
    if (!open) {
        return null;
    }

    const handleWhiteBtn = () => {
        onCancel?.();
        onClose();
    };
    const handleBlackBtn = () => {
        onConfirm?.();
        onClose();
    };


    return (
        <Modal.BackGround containerWidth="464px" containerHeight="277px">
            <ModalWrap>
                <Modal.CommonHeader title={modalMsg.title}/>
                <Divider/>
                <Modal.CommonContent text={modalMsg.text} text2={modalMsg.text2}/>

                <Modal.CommonBottom>
                    {modalMsg.whiteBtnText && (
                        <Button className="white" onClick={handleWhiteBtn}>
                            {modalMsg.whiteBtnText}
                        </Button>
                    )}
                    <Button className={button2Variant} onClick={handleBlackBtn}>
                        {modalMsg.blackBtnText}
                    </Button>
                </Modal.CommonBottom>
            </ModalWrap>
        </Modal.BackGround>
    );
};


const ModalWrap = styled.div`
    display: flex;
    flex-direction: column;
    height: inherit;
`

const Divider = styled.div`
    height: 1px;
    width: calc(100% - 40px);
    background: #DDD;
    margin: 0 auto;
`;

const Button = styled.button`
    width: 100%;
    height: 59px;

    font-size: 20px;
    font-weight: 400;

    &.white {
        background-color: #FFFFFF;
        color: #000000;
        border: 1px solid #B2B3B4;
    }

    &.black {
        background-color: #000000;
        color: #FFFFFF;
        border: none;
    }

    &.gray {
        background-color: #323538;
        color: #FFFFFF;
        border: none;
    }
`;